import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export const newRouter = [
  {
    path: '/orga',
    name: 'orga',
    meta: {
      title: '大学',
      isChildren: false
    },
    component: resolve => import('@/view/orga/index').then(module => { resolve(module) }),
    children:[
      {
        path: 'University/:orgaId',
        name: 'University',
        meta: {
          title: '大学',
          isChildren: false
        },
        component: resolve => import('@/view/pages/home/University').then(module => { resolve(module) }),
      },
      {
        path: 'CreatedCourses/:orgaId',
        name: 'CreatedCourses',
        meta: {
          title: '创建课程',
          isChildren: false
        },
        component: resolve => import('@/view/orga/courses/course').then(module => { resolve(module) }),
      },
      {
        path: 'CitedCourses/:orgaId',
        name: 'CitedCourses',
        meta: {
          title: '引用课程',
          isChildren: false
        },
        component: resolve => import('@/view/orga/courses/CitedCourse').then(module => { resolve(module) }),
      },
      {
        path: 'news/:orgaId',
        name: 'news',
        meta: {
          title: '资讯',
          isChildren: false
        },
        component: resolve => import('@/view/orga/news/news').then(module => { resolve(module) }),
      },
      {
        path: 'events/:orgaId',
        name: 'events',
        meta: {
          title: '事件',
          isChildren: false
        },
        component: resolve => import('@/view/orga/news/events').then(module => { resolve(module) }),
      },
      {
        path: 'reports/:orgaId',
        name: 'reports',
        meta: {
          title: '报表',
          isChildren: false
        },
        component: resolve => import('@/view/orga/reportForm').then(module => { resolve(module) }),
      }
    ]
  },
  // 新增加页面路由
  {
    path: '/newhome',
    name: 'newhome',
    meta: {
      title: '根',
      isChildren: false
    },
    // 就这里失败啦
    component: resolve => import('@/view/home/training/trainingCourse').then(module => { resolve(module) }),
    redirect: '/trainingCourse/index/2/1574969319409807401',
    children: [
      {
        path: 'home',
        name: 'home',
        meta: {
          title: '首页',
          isChildren: false,
        },
        redirect: '/trainingCourse/index/2/1574969319409807401',
        // component: resolve => import('@/view/pages/home/home').then(module => { resolve(module) })
        component: resolve => import('@/view/home/training/training').then(module => { resolve(module) })
      },
      {
        path: 'homeabout',
        name: 'homeabout',
        meta: {
          title: '关于首页',
          isChildren: false
        },
        component: resolve => import('@/view/pages/home/about').then(module => { resolve(module) })
      },
      {
        path: 'education',
        name: 'education',
        meta: {
          title: '首页-教育',
          isChildren: false
        },
        component: resolve => import('@/view/pages/home/education').then(module => { resolve(module) })
      },
      {
        path: 'TeachingQuality',
        name: 'TeachingQuality',
        meta: {
          title: '首页-教学质量',
          isChildren: false
        },
        component: resolve => import('@/view/pages/home/TeachingQuality').then(module => { resolve(module) })
      },
      {
        path: 'curriculum',
        name: 'HomeCurriculum',
        meta: {
          title: '课程',
          isChildren: false
        },
        component: resolve => import('@/view/pages/curriculum/curriculum').then(module => { resolve(module) })
      },
      {
        path: 'curriculumlist',
        name: 'HomeCurriculumlist',
        meta: {
          title: '课程',
          isChildren: false
        },
        component: resolve => import('@/view/pages/curriculum/curriculumlist').then(module => { resolve(module) })
      },
      {
        path: 'tool',
        name: 'tool',
        meta: {
          title: '工具',
          isChildren: false
        },
        component: resolve => import('@/view/pages/tool/tool').then(module => { resolve(module) })
      },
      {
        path: 'list/:toolsClassifyId/:name',
        name: 'list',
        meta: {
          title: '工具列表',
          isChildren: false
        },
        component: resolve => import('@/view/pages/tool/list').then(module => { resolve(module) })
      },
      {
        path: 'network',
        name: 'network',
        meta: {
          title: '网络',
          isChildren: false
        },
        component: resolve => import('@/view/pages/network/network').then(module => { resolve(module) })
      },
      {
        path: 'news',
        name: 'news',
        meta: {
          title: '新闻',
          isChildren: false
        },
        component: resolve => import('@/view/pages/news/news').then(module => { resolve(module) })
      },
      {
        path: 'newsDetails/:id',
        name: 'newsDetails',
        meta: {
          title: '新闻',
          isChildren: false
        },
        component: resolve => import('@/view/pages/news/newsDetails').then(module => { resolve(module) })
      },
      {
        path: 'newsDetails2',
        name: 'newsDetails2',
        meta: {
          title: '新闻',
          isChildren: false
        },
        component: resolve => import('@/view/pages/news/newsDetails2').then(module => { resolve(module) })
      },
      {
        path: 'newsDetails3',
        name: 'newsDetails3',
        meta: {
          title: '新闻',
          isChildren: false
        },
        component: resolve => import('@/view/pages/news/newsDetails3').then(module => { resolve(module) })
      },
      {
        path: 'cuntact',
        name: 'cuntact',
        meta: {
          title: '联系我们',
          isChildren: false
        },
        component: resolve => import('@/view/pages/cuntact/cuntact').then(module => { resolve(module) })
      },
    ]
  },

]

export default newRouter


// WEBPACK FOOTER //
// ./src/router/router.js